import styled from '@emotion/styled';
import { theme } from 'theme';

export const Header = styled.header({
  // [theme.breakpoints.down('sm')]: {
  //   display: 'none',
  // },
});
